/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-ui-carbon'
], function(React, PropTypes, UI_CARBON_TOOLKIT, UI_CARBON) {
	const { SVGIcon, classnames } = UI_CARBON_TOOLKIT;
	const { OverflowMenu, OverflowMenuItem } = UI_CARBON;

	class DropDown extends React.Component {
		constructor(props){
			super(props);
			this.myRef = React.createRef();
		}

		_handleKeyDown = (evt, itemId) => {
			if(evt.keyCode === 32 || evt.keyCode === 13) {
				this._menuItemSelected(itemId);
			}
		}

		_menuItemSelected = (itemId) => {
			if (this.props.itemSpec.actions) {
				this.props.itemSpec.actions.apply(itemId, this.props.itemSpec.view.state.idList);
				this.setState({});
			}
		}

		render() {
			const itemSpec = this.props.itemSpec;
			let menuItems;

			if (itemSpec.actions) {
				menuItems = itemSpec.actions.getMenuItems(itemSpec.view.state.idList);
			}

			const isButtonDisabled = () => {
				if (!itemSpec.disabled) {
					return false;
				} else {
					return (typeof itemSpec.disabled === 'function') ? itemSpec.disabled() : true;
				}
			};

			return (
				<OverflowMenu
					style={{ height:40, width:40 }}
					walkme-data-id={itemSpec.name}
					data-id={itemSpec.name}
					ref={this.myRef}
					key={itemSpec.name}
					label={itemSpec.label}
					aria-label={itemSpec.label}
					title={itemSpec.label}
					className={classnames(itemSpec.className, { disabled: isButtonDisabled() })}
					renderIcon= {() => {
						return (
							<SVGIcon
								icon={itemSpec.icon}
								size={'small'}
								variant={'icon'}
							/>);
					}}
					// Rerender is needed to ensure available groups are accurate For the case where the grouping changes without using the menu (ie. undo/redo)
					onClick={() => this.setState({})}
					onKeyDown={(evt) => { if(evt.keyCode === 32) this.setState({}); }}
				>
					{menuItems.map((item) => {
						return (
							<OverflowMenuItem
								key={item.itemId}
								walkme-data-id={item.itemId}
								itemText={item.text}
								requireTitle
								onClick={() => this._menuItemSelected(item.itemId)}
								onKeyDown={(evt) => this._handleKeyDown(evt, item.itemId)}
							/>
						);
					})}
				</OverflowMenu>
			);
		}
	}

	DropDown.propTypes = {
		itemSpec: PropTypes.array
	};

	return DropDown;
});
